<template>
  <div v-if="project" class="le">
    <div>
      <el-row>
        <el-alert class="newBotError" v-if="newBotError"
          type="error">
          {{newBotError}}
        </el-alert>
      </el-row>
      <el-row>
          <el-col :span="2" >
            <el-input
                
                placeholder="filter bots"
                v-model="filterBots"
                clearable>
              </el-input>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="3">
                <el-input
                placeholder="new bot name"
                v-model="newBotName"
                clearable>
              </el-input>
          </el-col>
          <el-col class="airyButtons" :xs="{span: 12, offset: 0}" :span="2">
                <el-button
                  @click="createNewBot()"
                  id="addBot"
                  icon="el-icon-circle-plus"
                  type="info">Save
                </el-button>
          </el-col>
          <el-col class="airyButtons" :xs="{span: 24, offset: 0}" align="left" id="controlButtonsCol" :span="3">
              <el-button v-if="!getProjectState()" v-on:click="toggleState(true)">Activate project</el-button>
              <el-button v-if="getProjectState()" v-on:click="toggleState(false)">Deactivate project</el-button>
          </el-col>
          <el-col class="airyButtons" :xs="{span: 24, offset: 0}" align="left" id="botsStartCol" :span="3">
              <el-button type="info" icon="el-icon-upload" v-on:click="startAll()">Activate all bots</el-button>
          </el-col>
          <el-col class="airyButtons" :xs="{span: 24, offset: 0}" align="left" id="botsStartCol" :span="3">
              <el-button type="info" icon="el-icon-upload" v-on:click="stopAll()">Deactivate all bots</el-button>
          </el-col>
          <el-col class="airyButtons" :xs="{span: 24, offset: 0}" align="left" id="botsStartCol" :span="3">
              <el-button type="info" icon="el-icon-document-copy" v-on:click="copyProject()">Copy project</el-button>
          </el-col>
      </el-row>
    </div>
    <el-table
      v-loading="loading"
      :data="getBots()"
      style="width: 100%">
      <el-table-column  type="expand" sortable>
        <template slot-scope="props">
            <el-row>
                <BotStats :id="props.row.id" />
            </el-row>
        </template>
      </el-table-column>
      <el-table-column
        width="100"
        label="#"
        prop="id"
        sortable
        >
      </el-table-column>
      <el-table-column     
        sortable   
        label="Visits"
        align="center"
        width="100"
        prop="goal"
        >
        <template slot-scope="props">
            <Distribution :count="calculateCount(props)" :playbook="getPlaybooks(props.row.id)" />
        </template>
      </el-table-column>
      <el-table-column width="35">
        <template slot-scope="props">
          <RunNow :project_id="$route.params.id" :bot_id="props.row.id" />
        </template>
      </el-table-column>

      <el-table-column width="35">
        <template slot-scope="props">            
            <el-popconfirm
              confirmButtonText='Yes'
              cancelButtonText='Copy to another project'
              @onConfirm="handleConfirmCopy(props.row.id)"
              @onCancel="handleCancelCopy(props.row.id)"
              title="Copy to the same project?"
            >
              <i slot="reference" class="el-icon-document-copy cursored"></i>
            </el-popconfirm>
        </template>
        
      </el-table-column>
      <el-table-column width="25">
        <template slot-scope="props">
          <i v-on:click="deleteBot(props.row.id)" class="el-icon-delete cursored"></i>
        </template>
        
      </el-table-column>
      <el-table-column width="25" class="cursored">
        <template slot-scope="props">
          <Advanced :project="project" :projectAdvanced="advanced" :bot="props.row" />
          
        </template>
        
      </el-table-column>
      <el-table-column
        label="Name"
        prop="name"
        sortable
        >
          <template slot-scope="props">
            <div class="botNameCell">
              <div class="botNameMainLine">
                <router-link
                  class="botNameLink"
                  :title="props.row.name"
                  :to="'/project/'+$route.params.id+'/bot/' + props.row.id"
                >{{ props.row.name }}</router-link>
                <div
                  v-if="isSearchActionSummary(props.row.first_action_summary)"
                  class="botActionSummary"
                >
                  <span
                    class="botActionIcon"
                    :class="getSearchActionIconClass(props.row.first_action_summary.type)"
                  >{{ getSearchActionIcon(props.row.first_action_summary.type) }}</span>
                  <span
                    v-if="props.row.first_action_summary.site"
                    class="botActionSite"
                    :title="props.row.first_action_summary.site"
                  >{{ getDisplayDomain(props.row.first_action_summary.site) }}</span>
                  <span
                    v-if="props.row.first_action_summary.query_count > 1"
                    class="botActionCount"
                  >{{ props.row.first_action_summary.query_count }} keys</span>
                </div>
                <div
                  v-else-if="isOpenActionSummary(props.row.first_action_summary)"
                  class="botActionSummary"
                >
                  <span
                    class="botActionIcon botActionIconOpen"
                    title="Open"
                  >↗</span>
                  <span class="botActionName">open</span>
                  <span
                    v-if="props.row.first_action_summary.site_count > 1"
                    class="botActionCount"
                  >{{ props.row.first_action_summary.site_count }} sites</span>
                </div>
              </div>
              <div
                v-if="isSearchActionSummary(props.row.first_action_summary) && props.row.first_action_summary.queries.length"
                class="botActionExamples"
              >
                <span
                  v-for="(query, index) in props.row.first_action_summary.queries"
                  :key="props.row.id + '-query-' + index"
                  class="botActionExample"
                  :title="query"
                >{{ query }}</span>
              </div>
              <div
                v-else-if="isOpenActionSummary(props.row.first_action_summary) && props.row.first_action_summary.sites.length"
                class="botActionExamples"
              >
                <span
                  v-for="(site, index) in props.row.first_action_summary.sites"
                  :key="props.row.id + '-site-' + index"
                  class="botActionExample"
                  :title="site"
                >{{ getDisplayDomain(site) }}</span>
              </div>
            </div>
          </template>
      </el-table-column>
      <el-table-column
        width="100"
        label="Status"
        prop="status"
        sortable
        >
          <template slot-scope="props">
              <el-tag v-on:click="handleConfirm(props.row)" slot="reference" class="cursored" v-if="props.row.status=='active'" type="info">
                {{ props.row.status }}
              </el-tag>
              <el-tag v-on:click="handleConfirm(props.row)" slot="reference" v-else class="cursored" type="danger">
                {{ props.row.status }}
              </el-tag>    
            
          </template>
      </el-table-column>
      <el-table-column
        align="center"
        width="65"
        label="Whole day"
        >
        <template slot-scope="props">
           <DaySection :bot_id="props.row.id" :type="'any'" :project="project" :playbooks="getPlaybooksByTime(props.row.id,'any')"/>
        </template>
      </el-table-column>
      <el-table-column
        width="65"
        label="6 - 12"
        align="center"
        >
        <template slot-scope="props">
           <DaySection :bot_id="props.row.id" :type="'morning'" :project="project" :playbooks="getPlaybooksByTime(props.row.id,'morning')"/>
        </template>
      </el-table-column>
      <el-table-column
        width="65"
        label="12 - 18"
        align="center"
        >
        <template slot-scope="props">
           <DaySection :bot_id="props.row.id" :type="'day'" :project="project" :playbooks="getPlaybooksByTime(props.row.id,'day')"/>
        </template>
      </el-table-column>
      <el-table-column
        width="65"
        label="6 - 00"
        align="center"
        >
        <template slot-scope="props">
           <DaySection :bot_id="props.row.id" :type="'evening'" :project="project" :playbooks="getPlaybooksByTime(props.row.id,'evening')"/>
        </template>
      </el-table-column>
      <el-table-column
        width="65"
        align="center"
        label="00-6"
        >
        <template slot-scope="props">
           <DaySection :bot_id="props.row.id" :type="'night'" :project="project"  :playbooks="getPlaybooksByTime(props.row.id,'night')"/>
        </template>
      </el-table-column>
      <el-table-column
        label="Last updated"
        align="center"
        prop="updated_at"
        width="150"
        sortable
        >
        <template slot-scope="props">
           {{getDate(props.row.updated_at)}}
        </template>
      </el-table-column>
    </el-table>
    <Advanced :show="view.advanced" />
    <ScheduledCount />
    <el-dialog
      title="Select project to copy this bot to"
      :visible.sync="dialogCopy.visible"
      width="400px"
      :before-close="handleCloseNow">
      <div class="inputContainerNow">
        <el-row class="nowRow">
          <el-col :span="12" class="nameCol">
            Project ID:
          </el-col>
          <el-col :span="12">
            <el-input size="mini"  v-model="dialogCopy.project_id"></el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseNow()">Cancel</el-button>
        <el-button icon="el-icon-danger" type="primary" @click="copyBotToAnotherProject(dialogCopy.bot_id)">Copy</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="Run this bot right now"
      :visible.sync="dialogNow.visible"
      width="400px"
      :before-close="handleCloseNow">
      <div class="inputContainerNow">
        <el-row class="nowRow">
          <el-col :span="12" class="nameCol">
            Delay
          </el-col>
          <el-col :span="12">
            <el-input-number size="mini" :step="1" v-model="dialogNow.delay"></el-input-number>
          </el-col>
        </el-row>
        <el-row class="nowRow">
          <el-col :span="12" class="nameCol">
            Tasks
          </el-col>
          <el-col :span="12">
            <el-input-number size="mini" :step="5" v-model="dialogNow.tasks"></el-input-number>
          </el-col>
          </el-row>
        <el-row class="nowRow">
          <el-col :span="12" class="nameCol">
              Repeats
          </el-col>
          <el-col :span="12">
            <el-input-number size="mini" :step="50" v-model="dialogNow.repeats"></el-input-number>
          </el-col>
        </el-row>
        <el-row class="nowRow">
          <el-col :span="12" class="nameCol">
            Playbook id
          </el-col>
          <el-col :span="12">
            <el-input class="playbookId" size="mini" :width="50" :step="50" v-model="dialogNow.playbook_id"></el-input>
          </el-col>
        </el-row>
        <el-row class="nowRow">
          <el-col :span="12" class="nameCol">
            Retry count
          </el-col>
          <el-col :span="12">
            <el-input-number size="mini" :width="50" :step="1" v-model="dialogNow.retry_num"></el-input-number>
          </el-col>
        </el-row>
        <el-row class="nowRow">
          <el-divider><i class="el-icon-star-on"></i></el-divider>
          <el-col :span="12" class="nameCol">
            Record video:
          </el-col>
          <el-col :span="12" class="nameCol">
            <el-switch
              v-model="dialogNow.video_ratio"
              >
            </el-switch>
          </el-col>
        </el-row>
        <el-row>

        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseNow()">Cancel</el-button>
        <el-button icon="el-icon-danger" type="primary" @click="runBotNow(dialogNow.bot_id)">RUN</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DaySection from './DaySection.vue';
import ScheduledCount from './ScheduledCount.vue';
import PlaybooksList from './PlaybooksList.vue';
import Distribution from './Distribution.vue';
import Advanced from './Advanced/Advanced.vue';
import BotStats from './Bot/BotStats.vue';
import RunNow from './Bot/RunNow.vue';
import moment from 'moment';
import { mapState } from 'vuex';

export default {
    name: 'Scheduler',
    components: {
        DaySection,
        PlaybooksList,
        Advanced,
        ScheduledCount,
        Distribution,
        BotStats,
        RunNow
    },
    data () {
        return {
          filterBots:'',
            view:{
                advanced:false,
                entity: {

                }
            },
            newBotName:'',
            newBotError: '',
            dialogNow: {
              visible: false,
              delay: 1,
              tasks: 1,
              repeats: 1,
              bot_id: -1,
              project_id:-1,
              video_ratio: false,
              playbook_id: 0,
              retry_num:0
            },
            dialogCopy: {
              project_id: 0,
              bot_id: 0,
              visible: false
            }
        }
    },
    props: {
        project: {
            type: Object,
            default: () => {}
        },
        bots: {
            type: Array,
            default: () => []
        },
        advanced: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
      ...mapState('project', {
          loading: 'loading'
        }),
        
    },
    mounted: function () {
        var that = this;
        this.$store.subscribe((mutation, state) => {
            if (mutation.type === 'bot/BOT_COPIED') {  
              //this.$store.dispatch('project/loadCompleteProject', {params: {id:that.project.id}});
              //document.getElementById('app').scrollTop = document.getElementById('app').scrollHeight;
              this.$router.push({ name: 'bot', params: { project_id: mutation.payload.data.project_id,id: mutation.payload.data.id } });
            }
            if (mutation.type === 'project/PROJECT_COPIED') {  
              this.$router.push({ name: 'project', params: { id: mutation.payload.data.id } });
            }
            if (mutation.type === 'project/BOT_UPDATED') {  
              
            }
            if (mutation.type === 'project/BOT_RAN_NOW') {
              this.dialogNow.visible = false;
            }
            if (mutation.type === 'project/REFRESH_BOTS') {
              that.$store.dispatch('project/loadAllBotsByProject', { 
                params: {
                  project_id: that.$route.params.id, 
                } 
              });
            }
            if (mutation.type === 'project/FULL_PROJECT_RELOADED') {
                window.scrollTo(0,document.body.scrollHeight);
            }
        })
    },
    methods: {
      isSearchActionSummary(summary) {
        return summary &&
          ['yandex_search', 'google_search'].includes(summary.type) &&
          Array.isArray(summary.queries);
      },
      isOpenActionSummary(summary) {
        return summary && summary.type === 'open' && Array.isArray(summary.sites);
      },
      getSearchActionIcon(type) {
        return type === 'yandex_search' ? 'Я' : 'G';
      },
      getSearchActionIconClass(type) {
        return type === 'yandex_search' ? 'botActionIconYandex' : 'botActionIconGoogle';
      },
      getDisplayDomain(value) {
        return String(value || '')
          .trim()
          .replace(/^[a-z][a-z0-9+.-]*:\/\//i, '')
          .replace(/^\/\//, '')
          .split(/[/?#]/)[0]
          .replace(/:\d+$/, '');
      },
      getDate(date) {
        return moment(date).format('YYYY.MM.DD HH:mm');
      },
      sortTableId(a, b) {
        
        return 1;
      },
      getTitle(row) {
        switch(row.status) {
          case 'active': return 'Disable bot?';
          case 'inactive': return 'Activate bot?';
          default: return 'Activate bot?';
        }
      },
      deleteBot(id) {
        var that = this;
        this.$confirm('This will permanently delete this bot and it\'s scenario.', 'Uvaga', 
        {
            confirmButtonText: 'Delete',
            cancelButtonText: 'Cancel',
            type: 'warning'
        }).then(() => {
            that.$store.dispatch('project/deleteBot', { 
              params: {
                project_id: that.$route.params.id, 
                bot_id: id,
              } 
            });
            /*this.$message({
                type: 'success',
                message: 'Delete completed'
            });*/
            }).catch(() => {
            this.$message({
                type: 'info',
                message: 'Delete canceled'
            });          
          });
      },
      handleConfirm(row) {
        if (row.status == 'active') {
          //deactivate
          this.$store.dispatch('project/stopBot', {
            project_id: parseInt(this.$route.params.id),
            bot_id: row.id,
          });
        } else {
          //activate
          this.$store.dispatch('project/startBot', {
            project_id: parseInt(this.$route.params.id),
            bot_id: row.id,
          });
        }
      },
      copyProject() {
        var model = {
                project_id: parseInt(this.$route.params.id),
                name: this.project.name + " [copy]"
              }
        this.$store.dispatch('project/copyProject', {model: model});
      },
      handleConfirmCopy(id) {
        this.copyBot(id, this.$route.params.id, this.$route.params.id);
      },
      copyBotToAnotherProject(id) {
        this.copyBot(id, this.$route.params.id, this.dialogCopy.project_id);
      },
      handleCancelCopy(id) {
        this.dialogCopy.visible = true;
        this.dialogCopy.bot_id = id;
        this.dialogCopy.project_id = this.$route.params.id;
      },
      handleCancel() {
        alert('no')
      },
      handleCloseNow() {
        this.dialogNow.visible = false;
        this.dialogCopy.visible = false;
      },
      handleNow(index, row) {
        this.dialogNow.visible = true;
        this.dialogNow.bot_id = row.id;
        this.dialogNow.project_id = this.$route.params.id;
      },
      handleCopyTo(botId, projectId) {
        this.dialogCopy.visible = true;
        this.dialogCopy.bot_id = row.id;
        this.dialogCopy.project_id = this.$route.params.id;
      },
      runBotNow(id) {
        var ratio = (this.dialogNow.video_ratio == true) ? 100 : 0; 
        this.$store.dispatch('project/scheduleBotNow', {
          project_id:this.$route.params.id,
          bot_id: id,
          delay: this.dialogNow.delay,
          repeats: this.dialogNow.repeats,
          tasks: this.dialogNow.tasks,
          playbook_id: this.dialogNow.playbook_id,
          video_ratio: ratio,
          retry_num: this.dialogNow.retry_num
        });
      },
      getProjectState() {
        var state = this.project.status;
        switch(state) {
          case 'active':
            return true;
            break;
          case 'finished':
          case 'inactive':
            return false;
        }
      },
      toggleState(newVal) {
        if (newVal === true) {
          this.$store.dispatch('project/activateProjectAction', {
              params: {
                project_id: this.$route.params.id,
                name: this.project.name
              }
            });
        }
        
        if (newVal === false) {
          this.$store.dispatch('project/deactivateProjectAction', {
              params: {
                project_id: this.$route.params.id,
                name: this.project.name
              }
            });
        }
      },
      startAll() {
          this.$store.dispatch('project/startBots', {
            project_id: parseInt(this.$route.params.id),
          });
      },
      stopAll() {
          this.$store.dispatch('project/stopBots', {
            project_id: parseInt(this.$route.params.id),
          });
      },
      createNewBot() {
        if (this.newBotName.length) {
          this.newBotError = '';
          //save dis
          this.$store.dispatch('project/createBot', {params: {project_id:this.$route.params.id, name: this.newBotName}});
          return;
        }

        this.newBotError = 'Please, specfify a name';
      },
      toggleAdvanced(state) {
          this.view.advanced = state;
      },
      copyBot(botId, projectId, toProjectId) {
          var name = this.getBotName(botId);
          var model = {
          bot_id: botId,
          project_id: projectId,
          to_project_id: toProjectId,
          name: name + ' [copy]'
        }

        this.$store.dispatch('bot/copyBot', {model: model});
      },
      
      getBots() {
        var bots = this.$store.state.project.bots.data;
        if (this.filterBots)
        {
            bots = bots.filter(
              function(bot){
                if (!isNaN(this.filterBots)) {
                  //this is number so lets filter by number
                  if (bot.id == this.filterBots) {
                    return true;
                  }
                }
                if (bot.name.toLowerCase().indexOf(this.filterBots.toLowerCase()) != -1) {
                  return true;
                }
              }, this
            );
        }
        return bots;  
      },
      calculateCount(props) {
        return (props.row.goal == null) ? 0: props.row.goal;
      },
      getBotName(id) {//todo this is not the first one, move to a service
          var data = this.bots.filter(
              bot => bot.id == id
          );

          return (data[0] == undefined) ? 'unknown bot' : data[0].name;
      },
      isBotScheduled(id) {
          var pbs = this.getPlaybooks(id);
          if( pbs[0].goal > 0 ) return true;
          return false;
      },
      getPlaybooks(botId) {
          return this.$store.state.project.bots.data.filter(bot => bot.id == botId);
      },
      getPlaybooksByTime(botId, time) {
          var filter = this.getPlaybooks(botId);
          var ready = [];//filter.filter(playbook => playbook.time_of_days == time);
          return filter;
      },
      getAverageByBot(botId) {
          var sum = 0;
          var pbs = this.getPlaybooks(botId);
          
          pbs.forEach(function(item, i, pbs) {
              sum += item.goal;
          });

          return sum;
      }
    }
}
</script>

<style lang="scss" scoped>  
  .runNowIcon{
    margin-top:15px;
    cursor: pointer;
  }

  .playbookId .el-input__inner{
    width:50px !important;
  }

  .cursored {
    cursor: pointer;
  }

  .airyButtons {
    margin-bottom:5px;
    float:left;
  }

  .botNameCell {
    display: flex;
    flex-direction: column;
    min-width: 0;
    overflow: hidden;
  }

  .botNameMainLine {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    min-width: 0;
    overflow: hidden;
  }

  .botNameLink {
    flex: 0 1 auto;
    min-width: 40px;
    max-width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .botActionSummary {
    display: flex;
    flex: 1 1 auto;
    flex-wrap: nowrap;
    align-items: center;
    min-width: 0;
    margin-left: 8px;
    overflow: hidden;
    color: #909399;
    font-size: 11px;
    line-height: 18px;
  }

  .botActionExamples {
    display: flex;
    flex-wrap: nowrap;
    min-width: 0;
    margin-top: 4px;
    overflow: hidden;
    font-size: 11px;
    line-height: 18px;
  }

  .botActionIcon {
    display: inline-flex;
    flex: 0 0 18px;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    margin-right: 6px;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    background: #fff;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    box-sizing: border-box;
  }

  .botActionIconYandex {
    color: #ff0000;
  }

  .botActionIconGoogle {
    color: #4285f4;
  }

  .botActionIconOpen {
    color: #67c23a;
  }

  .botActionSite {
    max-width: 220px;
    margin-right: 6px;
    overflow: hidden;
    color: #606266;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .botActionName,
  .botActionCount,
  .botActionExample {
    border-radius: 3px;
  }

  .botActionName {
    margin-right: 6px;
    color: #606266;
    font-weight: 600;
  }

  .botActionCount {
    flex: 0 0 auto;
    margin-right: 4px;
    padding: 0 5px;
    color: #909399;
    background: #f4f4f5;
  }

  .botActionExample {
    flex: 0 1 auto;
    min-width: 0;
    max-width: 180px;
    margin-right: 4px;
    padding: 0 5px;
    overflow: hidden;
    color: #606266;
    text-overflow: ellipsis;
    white-space: nowrap;
    background: #f4f4f5;
    border: 1px solid #e4e7ed;
  }
</style>
